import React from 'react'

const Footer = (props) => {
  return (
    <div id='footer'>
      <h3>Powered by VirtualAPT</h3>
    </div>
  )
}

export default Footer